
import { Button, Checkbox, Alert } from 'element-ui';
import StripePayment from '@/services/payments/StripePayment';
import cartMixin from '@/mixins/cartMixin';
import addressMixin from '@/mixins/addressMixin';

import { loadStripe } from '@stripe/stripe-js';

// export default ({ app }, inject) => {
//   inject('stripe', stripePromise);
// };

export default {
  mixins: [cartMixin, addressMixin],
  props: {
    paymentMethod: {
      type: Object,
    },
    paymentMethodTypes: {
      type: String,
      default: 'card', //'card,klarna,...'
    },
    name: {
      type: String,
      default: 'card', //'card,klarna,...'
    },
  },
  data() {
    return {
      token: null,
      elements: null,
      clientSecret: null,
      stripe: null,
      generalConditionsSale: false,
      loading: true,
      error: null,
    };
  },
  computed: {
    stripePayment() {
      return new StripePayment({
        cart: this.cart,
        auth: this.$auth,
        http: this.$http,
        addressService: this.addressService,
      });
    },
  },
  methods: {
    async initialize() {
      try {
        const data = await this.stripePayment.intent({
          paymentMethodTypes: this.paymentMethodTypes,
          isDigital: this.isDigitalCart,
        });

        this.clientSecret = data.ClientSecret;

        if (this.clientSecret) {
          this.elements = this.stripe.elements({
            clientSecret: this.clientSecret,
            locale: this.$i18n.locale ?? 'fr',
          });

          const paymentElementOptions = {
            layout: 'tabs',
          };

          if (this.isDigitalCart) {
            // Tell Stripe to avoid collecting shipping for express checkout methods like Apple/Google Pay
            // Note: For regular cards, it doesn't collect it unless we add the Address Element
            paymentElementOptions.fields = {
              billingDetails: {
                address: 'auto',
              },
            };
          }

          const paymentElement = this.elements.create(
            'payment',
            paymentElementOptions
          );

          paymentElement.mount(`#${this.name}-payment-element`);
        }
      } catch (error) {
        console.error('stripe : ', error);
        this.error = error;
      }

      this.loading = false;
    },
    async handleSubmit() {
      if (this.clientSecret) {
        if (await this.postData()) {
          this.toggleLoader(true);
          const idorder = this.cart.IdCart;

          const { error, paymentIntent } = await this.stripe.confirmPayment({
            elements: this.elements,
            confirmParams: {
              return_url: `${process.env.URL}cart/thanks/accepted?orderid=${idorder}&cartid=${this.cartService.idCart}`,
            },
            redirect: 'if_required',
          });

          if (error) {
            this.showMessage(error.message);
          } else if (paymentIntent && paymentIntent.status === 'succeeded') {
            // this.$gtag.event('add_payment_info', {
            //   payment_type: this.name,
            // });

            // this.$gtm.push({
            //   event: 'add_payment_info',
            //   ecommerce: {
            //     payment_type: this.name,
            //   },
            // });

            this.addPaymentInfoGtm(this.name);

            this.$router.push({
              path: this.localePath(
                `/cart/thanks/accepted?orderid=${idorder}&cartid=${this.cartService.idCart}`
              ),
            });
          }

          this.toggleLoader(false);
        }
      }
    },
    async postData() {
      try {
        const response = await this.stripePayment.postData({
          clientSecret: this.clientSecret,
          paymentMethod: this.paymentMethod,
        });
        return true;
      } catch (error) {
        return false;
      }
    },
    showMessage(messageText) {
      if (process.client) {
        const messageContainer = document.querySelector(
          `#${this.name}-payment-message`
        );

        messageContainer.classList.remove('hidden');
        messageContainer.textContent = messageText;

        setTimeout(function () {
          messageContainer.classList.add('hidden');
          messageContainer.textContent = '';
        }, 4000);
      }
    },
    toggleLoader(isLoading) {
      this.$store.commit('shared/wind/setIsLoading', isLoading);
    },
  },
  mounted() {
    const _stripe = loadStripe(process.env.STRIPE_PUBLIC_KEY);
    _stripe.then((stripe) => {
      this.stripe = stripe;
      this.initialize();
    });
  },
  components: {
    Button,
    Checkbox,
    Alert,
  },
};
